import React from "react";
import { Link } from "react-router-dom";

// Tek tip bölüm başlığı: renkli aksan + başlık/alt başlık + opsiyonel link.
function SectionHead({ title, subtitle, accent = "#11986e", to, linkLabel }) {
  return (
    <div className="hs-head">
      <div className="hs-head__titles">
        <span className="hs-head__bar" style={{ background: accent }} />
        <div className="hs-head__text">
          <h2>{title}</h2>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      </div>
      {to && linkLabel ? (
        <Link to={to} className="hs-head__link">
          {linkLabel} <i className="fa fa-long-arrow-right" />
        </Link>
      ) : null}
    </div>
  );
}

export default SectionHead;
